/* tslint:disable */
/* eslint-disable */
/**
 * LTCS gateway API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {exists} from '../runtime';
import type {OfferAdditionalOptionsInner} from './OfferAdditionalOptionsInner';
import {OfferAdditionalOptionsInnerFromJSON, OfferAdditionalOptionsInnerToJSON,} from './OfferAdditionalOptionsInner';
import type {OfferPropertiesInner} from './OfferPropertiesInner';
import {OfferPropertiesInnerFromJSON, OfferPropertiesInnerToJSON,} from './OfferPropertiesInner';

/**
 *
 * @export
 * @interface Offer
 */
export interface Offer {
    // TODO: not autogenerated: https://urbandrive.slack.com/archives/C04ADPD1UBT/p1698141453122109?thread_ts=1681747060.462479&cid=C04ADPD1UBT
    offerConfigId?: number;
    offerId?: number;
    label?: string;

    /**
     *
     * @type {string}
     * @memberof Offer
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof Offer
     */
    offerIdentifier?: string;
    /**
     *
     * @type {string}
     * @memberof Offer
     */
    prebookingOfferId?: string;
    /**
     *
     * @type {string}
     * @memberof Offer
     */
    description?: string;
    /**
     *
     * @type {string}
     * @memberof Offer
     */
    legalDescription?: string;
    /**
     *
     * @type {number}
     * @memberof Offer
     */
    preauthValue?: number;
    /**
     *
     * @type {number}
     * @memberof Offer
     */
    price?: number;
    /**
     *
     * @type {string}
     * @memberof Offer
     */
    priceFormatted?: string;
    /**
     *
     * @type {string}
     * @memberof Offer
     */
    currency?: string;
    /**
     *
     * @type {string}
     * @memberof Offer
     */
    customerGroupSlug?: string;
    /**
     *
     * @type {Array<string>}
     * @memberof Offer
     */
    tags?: Array<string>;
    /**
     *
     * @type {Array<OfferPropertiesInner>}
     * @memberof Offer
     */
    properties?: Array<OfferPropertiesInner>;
    /**
     *
     * @type {Array<OfferAdditionalOptionsInner>}
     * @memberof Offer
     */
    additionalOptions?: Array<OfferAdditionalOptionsInner>;
    /**
     *
     * @type {boolean}
     * @memberof Offer
     */
    isDraft?: boolean;
    /**
     *
     * @type {string}
     * @memberof Offer
     */
    buildSeries?: string;
    /**
     *
     * @type {string}
     * @memberof Offer
     */
    carCategory?: string;
}

/**
 * Check if a given object implements the Offer interface.
 */
export function instanceOfOffer(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function OfferFromJSON(json: any): Offer {
    return OfferFromJSONTyped(json, false);
}

export function OfferFromJSONTyped(json: any, ignoreDiscriminator: boolean): Offer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        // TODO: not autogenerated: https://urbandrive.slack.com/archives/C04ADPD1UBT/p1698141453122109?thread_ts=1681747060.462479&cid=C04ADPD1UBT
        'offerConfigId': !exists(json, 'offer_config_id') ? undefined : json['offer_config_id'],
        'offerId': !exists(json, 'offer_id') ? undefined : json['offer_id'],
        'label': !exists(json, 'label') ? undefined : json['label'],

        'name': !exists(json, 'name') ? undefined : json['name'],
        'offerIdentifier': !exists(json, 'offer_identifier') ? undefined : json['offer_identifier'],
        'prebookingOfferId': !exists(json, 'prebooking_offer_id') ? undefined : json['prebooking_offer_id'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'legalDescription': !exists(json, 'legal_description') ? undefined : json['legal_description'],
        'preauthValue': !exists(json, 'preauthValue') ? undefined : json['preauthValue'],
        'price': !exists(json, 'price') ? undefined : json['price'],
        'priceFormatted': !exists(json, 'price_formatted') ? undefined : json['price_formatted'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'customerGroupSlug': !exists(json, 'customer_group_slug') ? undefined : json['customer_group_slug'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'properties': !exists(json, 'properties') ? undefined : ((json['properties'] as Array<any>).map(OfferPropertiesInnerFromJSON)),
        'additionalOptions': !exists(json, 'additional_options') ? undefined : ((json['additional_options'] as Array<any>).map(OfferAdditionalOptionsInnerFromJSON)),
        'isDraft': !exists(json, 'is_draft') ? undefined : json['is_draft'],
        'buildSeries': !exists(json, 'build_series') ? undefined : json['build_series'],
        'carCategory': !exists(json, 'car_category') ? undefined : json['car_category'],
    };
}

export function OfferToJSON(value?: Offer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        // TODO: not autogenerated: https://urbandrive.slack.com/archives/C04ADPD1UBT/p1698141453122109?thread_ts=1681747060.462479&cid=C04ADPD1UBT
        'offer_config_id': value.offerConfigId,
        'offer_id': value.offerId,
        'label': value.label,

        'name': value.name,
        'offer_identifier': value.offerIdentifier,
        'prebooking_offer_id': value.prebookingOfferId,
        'description': value.description,
        'legal_description': value.legalDescription,
        'preauthValue': value.preauthValue,
        'price': value.price,
        'price_formatted': value.priceFormatted,
        'currency': value.currency,
        'customer_group_slug': value.customerGroupSlug,
        'tags': value.tags,
        'properties': value.properties === undefined ? undefined : ((value.properties as Array<any>).map(OfferPropertiesInnerToJSON)),
        'additional_options': value.additionalOptions === undefined ? undefined : ((value.additionalOptions as Array<any>).map(OfferAdditionalOptionsInnerToJSON)),
        'is_draft': value.isDraft,
        'build_series': value.buildSeries,
        'car_category': value.carCategory,
    };
}

